"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDatePickerIsoDateWrapper = useDatePickerIsoDateWrapper;
exports.useDateRangePickerIsoDateState = useDateRangePickerIsoDateState;
exports.useYearButtonProps = useYearButtonProps;
var _date = require("@internationalized/date");
var _react = require("react");
var _datepicker = require("@react-stately/datepicker");
function parseIsoDate(dateObject) {
  if (!dateObject) {
    return null;
  }
  if (typeof dateObject === 'string') {
    var dateString = dateObject;
    if (dateString) {
      try {
        return (0, _date.parseDate)(dateString);
      } catch (e) {
        //ignore parse errors
      }
    }
  } else if (dateObject && dateObject.calendar) {
    return dateObject;
  }
  return null;
}
function useDatePickerIsoDateWrapper(_ref) {
  var _parseIsoDate, _parseIsoDate2, _parseIsoDate3, _parseIsoDate4;
  var value = _ref.value,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    onChange = _ref.onChange,
    isDateUnavailable = _ref.isDateUnavailable;
  var propValueAsCalendarDate = (0, _react.useMemo)(function () {
    return parseIsoDate(value);
  }, [value]);
  (0, _react.useEffect)(function () {
    setValueAsCalendarDate(propValueAsCalendarDate);
  }, [propValueAsCalendarDate]);
  var _ref3 = (0, _react.useState)(propValueAsCalendarDate),
    _ref4 = _slicedToArray(_ref3, 2),
    valueAsCalendarDate = _ref4[0],
    setValueAsCalendarDate = _ref4[1];
  function handleCalendarDateChanged(calendarDate) {
    setValueAsCalendarDate(calendarDate);
    onChange && onChange(calendarDate === null || calendarDate === void 0 ? void 0 : calendarDate.toString());
  }
  var state = (0, _datepicker.useDatePickerState)({
    minValue: (_parseIsoDate = parseIsoDate(minValue)) !== null && _parseIsoDate !== void 0 ? _parseIsoDate : undefined,
    maxValue: (_parseIsoDate2 = parseIsoDate(maxValue)) !== null && _parseIsoDate2 !== void 0 ? _parseIsoDate2 : undefined,
    value: valueAsCalendarDate,
    isDateUnavailable: isDateUnavailable,
    onChange: handleCalendarDateChanged
  });
  var convertedProps = {
    minValue: (_parseIsoDate3 = parseIsoDate(minValue)) !== null && _parseIsoDate3 !== void 0 ? _parseIsoDate3 : undefined,
    maxValue: (_parseIsoDate4 = parseIsoDate(maxValue)) !== null && _parseIsoDate4 !== void 0 ? _parseIsoDate4 : undefined,
    value: valueAsCalendarDate
  };
  return {
    ariaState: state,
    convertedProps: convertedProps
  };
}

// FIXME: Missing types since DateRangePicker has not been converted yet
function useDateRangePickerIsoDateState(_ref2) {
  var _parseIsoDate5, _parseIsoDate6;
  var startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    minValue = _ref2.minValue,
    maxValue = _ref2.maxValue,
    onChange = _ref2.onChange;
  var propValueAsCalendarDates = (0, _react.useMemo)(function () {
    return {
      start: parseIsoDate(startDate),
      end: parseIsoDate(endDate)
    };
  }, [startDate, endDate]);
  var _ref5 = (0, _react.useState)(propValueAsCalendarDates),
    _ref6 = _slicedToArray(_ref5, 2),
    valueAsCalendarDate = _ref6[0],
    setValueAsCalendarDate = _ref6[1];
  (0, _react.useEffect)(function () {
    setValueAsCalendarDate(propValueAsCalendarDates);
  }, [propValueAsCalendarDates]);
  function handleCalendarDatesChanged(calendarDates) {
    setValueAsCalendarDate(calendarDates);
    onChange && onChange({
      startDate: calendarDates === null || calendarDates === void 0 ? void 0 : calendarDates.start.toString(),
      endDate: calendarDates === null || calendarDates === void 0 ? void 0 : calendarDates.end.toString()
    });
  }
  var ariaState = (0, _datepicker.useDateRangePickerState)({
    minValue: (_parseIsoDate5 = parseIsoDate(minValue)) !== null && _parseIsoDate5 !== void 0 ? _parseIsoDate5 : undefined,
    maxValue: (_parseIsoDate6 = parseIsoDate(maxValue)) !== null && _parseIsoDate6 !== void 0 ? _parseIsoDate6 : undefined,
    // FIXME: Hack for now since DateRangePicker has not been converted to TS yet. Fix when converting DateRangePicker.
    value: valueAsCalendarDate,
    onChange: handleCalendarDatesChanged
  });
  var convertedProps = {
    minValue: parseIsoDate(minValue),
    maxValue: parseIsoDate(maxValue),
    value: valueAsCalendarDate
  };
  return {
    ariaState: ariaState,
    convertedProps: convertedProps
  };
}
function useYearButtonProps(state) {
  return {
    prevYearButtonProps: {
      'aria-label': 'Previous year',
      onPress: function onPress() {
        return state.setFocusedDate(state.focusedDate.add({
          years: -1
        }));
      }
    },
    nextYearButtonProps: {
      'aria-label': 'Next year',
      onPress: function onPress() {
        return state.setFocusedDate(state.focusedDate.add({
          years: 1
        }));
      }
    }
  };
}